import { createFileRoute } from '@tanstack/react-router'
import { PengaturanDesa } from '../../../../components/PengaturanDesa'

export const Route = createFileRoute('/platform/desa/$desaId/pengaturan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <PengaturanDesa desaId={desaId} />
  },
})
